import { createTheme } from "@mui/material/styles";

export const ExpoTheme = createTheme({
  palette: {
    primary: {
      main: "#02475f", // Your base deep teal
      light: "#06698b",
      dark: "#012d3d",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#f50057",
    },
    background: {
      default: "#f8f9fa", // A subtle off-white for the main app background
      paper: "#ffffff", // Crisp white for drawers and cards
    },
    action: {
      // Sets global hover states to be a very light tint of black/grey
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      selected: "rgba(2, 71, 95, 0.08)", // Light tint of your primary color
      selectedOpacity: 0.08,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#02475f",
          boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.12)", // Softer, modern shadow
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#ffffff",
          borderRight: "1px solid rgba(0, 0, 0, 0.08)", // Very subtle border instead of harsh lines
        },
      },
    },
    // Modernize all List Items globally
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px", // Gives that floating "pill" look
          margin: "4px 12px", // Adds spacing around the edges
          padding: "8px 16px",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            // A crisp, light tint of your primary color on hover
            backgroundColor: "rgba(2, 71, 95, 0.06)",
            color: "#02475f",
            "& .MuiListItemIcon-root": {
              color: "#02475f", // Makes icons pop with primary color on hover
            },
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "40px",
          transition: "color 0.2s ease-in-out",
        },
      },
    },
  },
});
